import Button from '@components/Button';
import Row from '@components/Row';
import styled from '@emotion/styled';
import { ShopResponse } from '@models/shop';
import { useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

interface Props {
    onOrder: () => void;
    shop: ShopResponse;
}

function SheetFooter({ onOrder, shop }: Props) {
    const { name, id } = shop;
    const { t } = useTranslation('shopLocation');
    const isOpen = shop.orderStatus === 'OPEN';
    const { pop } = useFlow();
    return (
        <Container fullWidth spacing={2}>
            <ActionButton variant='tone' onClick={pop}>
                {t('button.selectOtherShop')}
            </ActionButton>
            <ActionButton disabled={!isOpen}
                id='shop-location-select-shop-button'
                aria-label='select-shop-button'
                data-shop-id={id}
                data-shop-name={name}
                onClick={onOrder} >
                {isOpen ? t('button.order') : t('button.preparing')}
            </ActionButton>
        </Container>
    );
}

const Container = styled(Row)`
    padding: var(--spacing-4) var(--spacing-4) calc(var(--spacing-4) + var(--safe-area-bottom));
`;

const ActionButton = styled(Button)`
    flex: 1;
    padding: 0;
`;

export default SheetFooter;
